import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderTable } from './banner-list.interface';
import { ModalsComponent } from './Modals/Modals.component';
import { BannerListService } from '../../../service/api/builk/banner-list.service';
import { BannerFetchData, BannerListModel, BannerModel } from '../../../model/builk/banner-list/BannerFetchData.model';

@Component({
  selector: 'app-banner-list',
  templateUrl: './banner-list.component.html',
  styleUrls: ['./banner-list.component.scss']
})
export class BannerListComponent implements OnInit {

  //table
  headers: HeaderTable[] = [
    {
      title: 'No.',
      width: '80px',
      justify: 'center',
      align: 'center'
    },
    {
      title: 'Modal or Banner Page',
      width: '',
      justify: 'center',
      align: 'center'
    },
    {
      title: 'Preview Desktop',
      width: '250px',
      justify: 'center',
      align: 'center'
    },
    {
      title: 'Preview Mobile',
      width: '250px',
      justify: 'center',
      align: 'center'
    },
    {
      title: 'Status',
      width: '200px',
      justify: 'center',
      align: 'center'
    },
    {
      title: '',
      width: '200px',
      justify: 'center',
      align: 'center'
    },
  ]
  banners:BannerListModel = new BannerListModel;
  showBoundaryLinks = true;
  showDirectionLinks = true;
  pages: BannerFetchData = new BannerFetchData;
  perpage: number = 13;
  isLoading:boolean = false;
  @ViewChild("bannermodals") modal: ModalsComponent;

  constructor(
    private BannerService: BannerListService
  ) { }

  ngOnInit() {
    this.pages.page = 1;
    this.pages.itemPerPage = this.perpage;
    this.Fetch(this.pages);
  }

  Fetch(p: BannerFetchData) {
    try {
      this.BannerService.fetchBanner(p).subscribe(x => {
      this.banners.banners = x.bannerList;
      this.banners.count = x.count;
      console.log(this.banners);
      });
    }
    catch(e) {
      console.error(e);
    }
  }

  Toggle(id: number) {
    if(!id) return
    var banner: BannerModel[] = this.banners.banners.filter(x => {
      return x.bannerSurrId === id;
    });
    if(banner.length<=0) return;
    this.BannerService.updateBanner(banner[0]).subscribe(x => {
      console.log(x);
    })
  }

  Create() {
    this.modal.openCreate();
  }

  Edit(id: number) {
    if(!id) return
    var banner: BannerModel[] = this.banners.banners.filter(x => {
      return x.bannerSurrId === id;
    });
    if(banner.length<=0) return;
    console.log(banner[0]);
    this.modal.openEdit(banner[0]);
  }

  ChangePaged(p: BannerFetchData) {
    if(!p) return;
    this.pages.page = p.page;
    this.Fetch(this.pages);
  }

  GeneratIndex(index: number) {
    let pagination = (this.pages.page - 1) * this.pages.itemPerPage;
    return pagination + index;
  }

  UpdateBanner(model: BannerModel[]) {
    this.banners.banners = model;
  }
}

